require('./brokerExpiredMiFIDTest.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const moment = require('moment');

// @commons
const { OKLink } = require('commonsComponents/OKLink');

// @components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @constants
const { DATE_FORMAT_COMPLETE, HYPHEN } = require('constants/index');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');

class BrokerExpiredMiFIDTest extends React.Component {

    render() {
        const { date } = this.props;
        const title = formatText('broker-convenienceMifidTestExpiredTitle');
        const subtitle = formatText('broker-convenienceMifidTestExpiredSubtitle');
        const dateOfTest = date && moment(date).isValid()
            ? DateHelper.buildFormattedDate(date, DATE_FORMAT_COMPLETE)
            : HYPHEN;

        return (
            <ContentBox title={title} titleSeparator={true}>
                <h1 className="broker-expired-mifid-test__title">{subtitle}</h1>
                <p className="broker-expired-mifid-test__info">
                    {this.props.disclaimerText}
                </p>
                <div className="broker-expired-mifid-test__subtitle">
                    <FormattedText value="consultMiFID-dateLastEvaluation" format="uppercase"/>
                </div>
                <div className="broker-expired-mifid-test__info-bold">
                    {dateOfTest}
                </div>
                <footer className="broker-expired-mifid-test__footer">
                    <div className="row">
                        <div className="col-xs-6">
                            <OKLink
                                modifier="inherit-styles"
                                to={this.props.cancelPath}
                            >
                                <FormattedText value="broker-convenienceMifidTestExpiredCancelButton"/>
                            </OKLink>
                        </div>
                        <div className="col-xs-6 text-right">
                            <div className="broker-expired-mifid-test__button">
                                <OKButton modifier="ghost" onClick={this.props.onOmmitOperation}>
                                    <FormattedText value="broker-convenienceMifidTestExpiredSecondaryButton"/>
                                </OKButton>
                            </div>
                            <div className="broker-expired-mifid-test__button">
                                <OKButton modifier="secondary" onClick={this.props.onContinueOperation}>
                                    <FormattedText value="broker-convenienceMifidTestExpiredContinueButton"/>
                                </OKButton>
                            </div>
                        </div>
                    </div>
                </footer>
            </ContentBox>
        );
    }
}

BrokerExpiredMiFIDTest.propTypes = {
    onContinueOperation: PropTypes.func.isRequired,
    onOmmitOperation: PropTypes.func.isRequired,
    disclaimerText: PropTypes.string.isRequired,
    cancelPath: PropTypes.string.isRequired,
    isCancelPathAbsolute: PropTypes.string.isRequired,
    date: PropTypes.string,
};

module.exports = BrokerExpiredMiFIDTest;
